import groupsApi from "../../api/groupsApi";

const state = { 
    groups: [],
    group: {},
};

const actions = {
    createGroup(context, group) {
        return new Promise((resolve, reject) => {
            groupsApi
                .store(group)
                .then((response) => {
                    if (response.status === 201) {
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    updateGroup({ commit }, data) {
        return new Promise((resolve, reject) => {
            groupsApi
                .update(data)
                .then((response) => {
                    if (response.status === 200) {
                        commit("UPDATE_GROUP", response.data.groupUpdated);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    allGroups({ commit }) {
        return new Promise((resolve, reject) => {
            groupsApi
                .get()
                .then((response) => {
                    if (response.status === 200) {
                        commit("SET_GROUP", response.data);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    addUsersToGroup(context, data) {
        return new Promise((resolve, reject) => {
            groupsApi
                .addUserToGroup(data)
                .then((response) => {
                    if (response.status === 201) {
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    deleteUserFromGroup(context, data){
        return new Promise((resolve, reject) => {
            groupsApi
                .deleteUserFromGroup(data)
                .then((response) => {
                    if (response.status === 200) {
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    getGroup({ commit }, groupID) {
        return new Promise((resolve, reject) => {
            groupsApi
                .show(groupID)
                .then((response) => {
                    if (response.status === 200) {
                        commit("GET_GROUP", response.data.groups);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    deleteGroup({ commit }, groupId) {
        return new Promise((resolve, reject) => {
            groupsApi
                .delete(groupId)
                .then((response) => {
                    if (response.status === 200) {
                        commit("DELETE_GROUP", groupId);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

const mutations = {
    ADD_GROUP: (state, group) => {
        state.groups.unshift(group)
    },
    ADD_USERS_TO_GROUP: (state, user) => {
        state.users.unshift(user)
    },
    SET_GROUP: (state, groups) => (state.groups = groups),
    GET_GROUP: (state, group) => (state.group = group),
    UPDATE_GROUP: (state, group) => {
        const index = state.groups.findIndex(
            (group) => group.id === group.id
        );
        if (index !== -1) {
            state.groups.splice(index, 1, group);
        }
    },
    DELETE_GROUP: (state, groupID) => {
        state.groups = state.groups.filter(
            (group) => group.id !== groupID
        );
    }
};
export default { state, actions, mutations };